import React, { useState } from 'react';


import axios from 'axios';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Autocomplete, TextField } from '@mui/material';
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

function AddVideoReview() {
  const dispatch = useDispatch()
  const navigation = useNavigate()
  // State variables for form inputs and files
  const [category, setCategory] = useState('');
  const [videoFile, setVideoFile] = useState(null);
  const [coverFile, setCoverFile] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState({
    open: false,
    message: '',
  type: ''

  });

  // const [massage, setMassage] = useState('');

  const categories = [
    { label: "Home", value: "home" },
    { label: "About", value: "about" },
    { label: "Reviews", value: "reviews" },
  ];



  // Handle form submission
  const handleSubmit = async (e) => {
    dispatch({type:'LOADING'})
    e.preventDefault();

    // Validate that all fields are filled
    if (!category || !videoFile || !coverFile) {
      setOpen({  message: 'Please fill all fields and select both files.', type: 'error',open: true });
      return;
    }

    // Validate that video and cover file names (without extensions) are the same
    const videoFileName = videoFile.name.split('.').slice(0, -1).join('.');
    const coverFileName = coverFile.name.split('.').slice(0, -1).join('.');
    if (videoFileName !== coverFileName) {
      setOpen({ type: 'error', message: 'Video and cover photo names must be the same.',open: true });
      return;
    }

    setIsLoading(true);
    setResponseData(null);


    const formData = new FormData();
    formData.append('category', category);
    console.log(typeof(videoFile));
    console.log(typeof(coverFile));
      formData.append('video', videoFile);
      formData.append('cover_photo', coverFile);
  

    try {
      // Send POST request to PHP API
      const response = await axios.post(ENDPOINT+'upload-review-video.php', formData, SecurityHeaders);
      if (response) {
        if (response.data.status === "success") {
          dispatch({type:'DONE_LOADING'})
          setOpen({ type: 'success', message: 'Files uploaded successfully.',open: true });
          setOpen(true);
          setVideoFile(null);
          setCoverFile(null);
          setCategory('');
          navigation('/get-review-videos')
        } else {
          dispatch({type:'ERROR',payload:response.data.message})
          setIsLoading(false);
        }
      }
    }
    catch (error) {
      dispatch({type:'ERROR',payload:error.message})
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <>
     <Snackbar open={open.open} onClose={handleClose} autoHideDuration={4000} >
        <Alert
          
          severity={open.type === 'success' ? 'success' : 'error'}
          onClose={() => {}}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {open.message}
        </Alert>
      </Snackbar>
    
      <div className="vh-100 d-flex justify-content-center align-items-center">
        <div className="bg-white rounded shadow col-md-6 col-12 p-5">
          <h1 className='text-center'>Upload Video</h1>
          <form onSubmit={handleSubmit}>
          <div>
      <label className="mt-2">Category:</label>
      <Autocomplete
        className="mt-2"
        multiple // Enables multiple selection
        options={categories}
        getOptionLabel={(option) => option.label}
        value={categories.filter((cat) => category.includes(cat.value))} // Match selected values
        onChange={(_, newValues) => setCategory(newValues.map((cat) => cat.value))} // Update state as an array
        renderInput={(params) => (
          <TextField {...params} label="Select Category" variant="outlined"  />
        )}
      />
    </div>

            <div>
              <label className='mt-2'>Video File:</label>
              <input
                className='form-control mt-2'
                type="file"
                accept='video/*'
                onChange={(e) => setVideoFile(e.target.files[0])}
              />
            </div>
            <div>
              <label className='mt-2'>Cover Photo:</label>
              <input
                className='form-control mt-2'
                type="file"
                accept='image/*'
                onChange={(e) => setCoverFile(e.target.files[0])}
              />
            </div>
            <div className='mt-3 d-flex justify-content-center'>
              <button className='btn btn-primary' type="submit" disabled={isLoading}>
                {isLoading ? 'Uploading...' : 'Upload'}
              </button>
            </div>
        
          </form>
        </div>
      </div>
    </>
  );
}

export default AddVideoReview;